module.exports = __webpack_public_path__ + "static/media/user.8cc93363.svg";